var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "my-courses-color-picker" },
    _vm._l(_vm.color_count, function(i, index) {
      return _c("li", { class: _vm.getCSSClasses(index), attrs: { id: i } }, [
        _c(
          "a",
          {
            attrs: { title: _vm.getTitle(i, index) },
            on: {
              click: function($event) {
                return _vm.selectColor(index)
              }
            }
          },
          [_vm._v("\n            " + _vm._s(_vm.getTitle(i)) + "\n        ")]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }